module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"three-graces\"-in-pasadena-california-00885fa0d9beea3a257caf9889f2d746.png";